module.exports = require("serialport");